/**
 * Design tokens — single source for radii, focus, surfaces, and motion timing.
 * Tailwind theme (tailwind.config.js) remains the color palette authority.
 */

export const radius = {
  sm: 'rounded-xl',
  md: 'rounded-2xl',
  lg: 'rounded-3xl',
};

export const focusRing =
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400/70 focus-visible:ring-offset-2 ';

export const transition =
  'transition-[color,background-color,border-color,box-shadow,transform] duration-200 ease-out';

export const surface = {
  field:
    'border border-secondary-200/60 bg-white/80 text-secondary-900 shadow-[inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-md   ',
  fieldFocus:
    'focus:border-orange-300/80 focus:bg-white focus:ring-2 focus:ring-orange-400/25 focus:shadow-soft   ',
  panel:
    'border border-secondary-200/50 bg-white/60 shadow-[inset_0_1px_0_rgba(255,255,255,0.55)] backdrop-blur-md  ',
};

export const typography = {
  eyebrow: 'eyebrow',
  sectionTitle: 'section-title',
  statLabel: 'stat-label',
  formLabel: 'form-label',
};

export const layout = {
  container: 'container-premium',
  contentFlow: 'content-flow',
  sectionPadding: 'section-padding',
};
